import bundeslaenderRaw from "./data/bundeslaender.geo.json";
import bundeslaenderDataRaw from "./data/bundeslaender.csv";
import bundeslaenderDataRankingRaw from "./data/bundeslaender_ranking.csv";
import bundeslaenderDataComparisonRaw from "./data/bundeslaender_comparison.csv";

export const options = [
  {
    'id': 'rechtschreibung',
    'label': 'Rechtschreibung',
    'value': 'rechtschreibung'
  },
  {
    'id': 'lesen',
    'label': 'Lesen',
    'value': 'lesen'
  },
  {
    'id': 'mathematik',
    'label': 'Mathe',
    'value': 'mathematik'
  },
  {
    'id': 'zuhoeren',
    'label': 'Zuhören',
    'value': 'zuhoeren'
  }
 ]



export const colorScales = {
  'rechtschreibung': ["#FFF0CA", "#FFDEAC", '#FAB475', '#EF8F4A', '#EA702C', '#C5C5C5'],
  'lesen': ["#FFD7CA", "#FFB9AF", '#F68F8F', '#F55E5E', '#D71E1E', '#C5C5C5'],
  'mathematik': ["#CAEFFF", "#ADDDFF", '#86AEFB', '#6A79FF', '#5A2CDA', '#C5C5C5'],
  'zuhoeren': ["#C9FEDB", "#ADF6C1", '#78DCB8', '#57AAA5', '#408696', '#C5C5C5']
}

export const aspectRatio = 0.74;
export const steps = [420, 440, 460, 480, 500, 998];



bundeslaenderRaw.features.forEach((d) => {
  d.properties.id = d.properties.id.replace("DE-", "").toLowerCase();
});

const bundeslaenderDataRanking = {}

bundeslaenderDataRankingRaw.forEach((o) => {
  bundeslaenderDataRanking[o.state] = {
    'rechtschreibung': o.rechtschreibung,
    'lesen': o.lesen,
    'mathematik': o.mathematik,
    'zuhoeren': o.zuhoeren
  }
})


options.forEach((o) => {
  bundeslaenderDataRaw.sort(function(a, b){
    return b[o.value] - a[o.value];
  });
  
  for (var i = 0; i < bundeslaenderDataRaw.length; i++) {
    if (!('ranking' in bundeslaenderDataRaw[i])) bundeslaenderDataRaw[i]['ranking'] = {};
    bundeslaenderDataRaw[i]['ranking'][o.value] = bundeslaenderDataRanking[bundeslaenderDataRaw[i].state][o.value];

  }

})




export const bundeslaender = bundeslaenderRaw;
export const bundeslaenderData = bundeslaenderDataRaw;
export const bundeslaenderDataComparison = bundeslaenderDataComparisonRaw;

export const charts = []

import import_bw from "./data/charts/bw.svg"; charts['bw'] = import_bw;
import import_by from "./data/charts/by.svg"; charts['by'] = import_by;
import import_be from "./data/charts/be.svg"; charts['be'] = import_be;
import import_bb from "./data/charts/bb.svg"; charts['bb'] = import_bb;
import import_hb from "./data/charts/hb.svg"; charts['hb'] = import_hb;
import import_hh from "./data/charts/hh.svg"; charts['hh'] = import_hh;
import import_he from "./data/charts/he.svg"; charts['he'] = import_he;
import import_mv from "./data/charts/mv.svg"; charts['mv'] = import_mv;
import import_ni from "./data/charts/ni.svg"; charts['ni'] = import_ni;
import import_nw from "./data/charts/nw.svg"; charts['nw'] = import_nw;
import import_rp from "./data/charts/rp.svg"; charts['rp'] = import_rp;
import import_sl from "./data/charts/sl.svg"; charts['sl'] = import_sl;
import import_sn from "./data/charts/sn.svg"; charts['sn'] = import_sn;
import import_st from "./data/charts/st.svg"; charts['st'] = import_st;
import import_sh from "./data/charts/sh.svg"; charts['sh'] = import_sh;
import import_th from "./data/charts/th.svg"; charts['th'] = import_th;
